import { MySphLightboxHelper } from "@sphtech/web2-core/auth";
import Cookies from "js-cookie";
import { ReactElement, useEffect } from "react";
import {
  getServiceFlagsByPubsId,
  PublicationShortname,
} from "src/app/auth/serviceIdentifier";
import LoadingBubbles from "src/app/components/LoadingBubbles";

import assertEnum from "../../../../.web2/web2-helpers/assertEnum";
import { COOKIE_KEY_PUBS_ID, COOKIE_PATH_PUBS_ID } from "../Home";
import {
  SUBSCRIBE_URL,
  SESSION_KEY_AUTH_ORIGIN,
  NLB_AUTH_ORIGIN,
  NLB_STG_AUTH_ORIGIN,
  NLB_SESSION_EXPIRED_URL,
} from "src/app/data.client";
import { COOKIE_PATH_KEY } from "@src/app/auth/cookiePath";

const MYSPH_LIGHTBOX_INIT_TIME = 2000;

export default function UnauthenticatedPage(): ReactElement {
  useEffect(() => {
    // Check if user is from NLB external login
    const authOrigin = sessionStorage.getItem(SESSION_KEY_AUTH_ORIGIN);
    const authOriginLower = authOrigin?.toLowerCase();
    if (
      authOriginLower &&
      (authOriginLower === NLB_AUTH_ORIGIN ||
        authOriginLower === NLB_STG_AUTH_ORIGIN)
    ) {
      window.location.href = NLB_SESSION_EXPIRED_URL;
      return;
    }

    const cookiePubsId = Cookies.get(COOKIE_KEY_PUBS_ID) ?? "";
    const pubId = assertEnum(PublicationShortname, cookiePubsId);

    if (pubId != null) {
      const path = Cookies.get(COOKIE_PATH_PUBS_ID);
      localStorage.setItem(COOKIE_PATH_KEY, `/${pubId}`);

      const currentUrl = new URL(window.location.href);

      const authOptions = {
        postLoginUrl: `${currentUrl.protocol}//${currentUrl.host}/${path}`,
        lan: "en",
        svc: getServiceFlagsByPubsId(pubId),
      };

      // setTimeout is used here due to the race condition between the MySphLightbox init and startRedirectAuth
      // future improvement is to use a promise / callback to ensure MySphLightbox is initialized before calling startRedirectAuth
      setTimeout(() => {
        MySphLightboxHelper.startRedirectAuth(authOptions);
      }, MYSPH_LIGHTBOX_INIT_TIME);
    } else {
      window.location.href = SUBSCRIBE_URL;
    }
  }, []);

  return <LoadingBubbles />;
}
